import AddPathologyForm from 'components/form/super-admin/pathology/AddPathologyForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'

export default class AddPathology extends Component {
    render() {
        return (
            <>
             <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Pathology</h4>
                                <AddPathologyForm />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
